import {
    CONFIRMED_GET_POLICIES
} from '../actions/policy/PolicyTypes';
const initialState = {
    policies: [],
    loading: false,
};

function PoliciesReducer(state = initialState, actions) {
    switch (actions.type) {
        case 'SET_POLICIES_LOADING':
            return {
                ...state,
                loading: actions.payload,
            };
        case CONFIRMED_GET_POLICIES:
            return {
                ...state,
                policies: actions.payload,
                loading: false,
            };
        default:
            return state;
    }
}

export {PoliciesReducer};